import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import "./profile.css";
import { toast } from "react-toastify";

function Profile() {
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");

  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/dashboard/login");
    }

    const fetchAdminData = async () => {
      try {
        const response = await axios.get("/admin/profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setAdminData(response?.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching admin data:", error);
      }
    };

    fetchAdminData();
  }, [navigate, token]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        await toast.promise(
          axios.post("/admin/profile/update-image", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }),
          {
            pending: "Uploading image...",
            success: "Image uploaded successfully!",
            error: "Failed to upload image.",
          }
        );

        setTimeout(() => {
          window.location.reload();
        }, 500);
      } catch (error) {
        if (error.response) {
          toast.error(
            error.response.data.message || "An error occurred while uploading."
          );
        } else if (error.request) {
          toast.error("Cannot connect to the server. Please try again later.");
        } else {
          toast.error("An unexpected error occurred.");
        }
      }
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <BeatLoader />
      </div>
    );
  }

  return (
    <section className="profile-section">
      <div className="container">
        <div className="profile-header">
          <div className="profile-logo">
            <div className="profile-background">
              <label htmlFor="fileInput" className="image-overlay">
                <img
                  src={
                    adminData?.image
                      ? adminData?.image
                      : "/photos/default-profile-image.webp"
                  }
                  alt="Avatar"
                />
                <div className="overlay-content">
                  <i className="uil uil-camera"></i>
                </div>
              </label>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e)}
              />
            </div>

            <div className="profile-info">
              <h5>{adminData?.name}</h5>
              <p>{adminData?.phone}</p>
              <p>{adminData?.location}</p>
            </div>
          </div>
          <div className="edit">
            <span>Edit</span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  d="M11.4001 18.1612L11.4001 18.1612L18.796 10.7653C17.7894 10.3464 16.5972 9.6582 15.4697 8.53068C14.342 7.40298 13.6537 6.21058 13.2348 5.2039L5.83882 12.5999L5.83879 12.5999C5.26166 13.1771 4.97307 13.4657 4.7249 13.7838C4.43213 14.1592 4.18114 14.5653 3.97634 14.995C3.80273 15.3593 3.67368 15.7465 3.41556 16.5208L2.05445 20.6042C1.92743 20.9852 2.0266 21.4053 2.31063 21.6894C2.59466 21.9734 3.01478 22.0726 3.39584 21.9456L7.47918 20.5844C8.25351 20.3263 8.6407 20.1973 9.00498 20.0237C9.43469 19.8189 9.84082 19.5679 10.2162 19.2751C10.5343 19.0269 10.823 18.7383 11.4001 18.1612Z"
                  fill="#9A7462"
                ></path>{" "}
                <path
                  d="M20.8482 8.71306C22.3839 7.17735 22.3839 4.68748 20.8482 3.15178C19.3125 1.61607 16.8226 1.61607 15.2869 3.15178L14.3999 4.03882C14.4121 4.0755 14.4246 4.11268 14.4377 4.15035C14.7628 5.0875 15.3763 6.31601 16.5303 7.47002C17.6843 8.62403 18.9128 9.23749 19.85 9.56262C19.8875 9.57563 19.9245 9.58817 19.961 9.60026L20.8482 8.71306Z"
                  fill="#9A7462"
                ></path>{" "}
              </g>
            </svg>
          </div>
        </div>
        {/* className="fa-envelope" */}
        <div className="profile-footer">
          <h1>Account Details</h1>
          <div className="profile-footer-container">
            <div className="profile-form">
              <form>
                <div className="form-group inputWithIcon">
                  <label>Name</label>
                  <div className="input-comp">
                    <input type="email" placeholder={adminData?.name} />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="fa-envelope"
                    >
                      <path
                        d="M12 10C14.2091 10 16 8.20914 16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6C8 8.20914 9.79086 10 12 10Z"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                      />
                      <path
                        d="M20 17.5C20 19.985 20 22 12 22C4 22 4 19.985 4 17.5C4 15.015 7.582 13 12 13C16.418 13 20 15.015 20 17.5Z"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                      />
                    </svg>
                  </div>
                </div>
                <div className="form-group inputWithIcon">
                  <label>Location</label>
                  <div className="input-comp">
                    <input type="text" placeholder={adminData?.location} />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="fa-envelope"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 2C14.3869 2 16.6761 2.94821 18.364 4.63604C20.0518 6.32387 21 8.61305 21 11C21 14.074 19.324 16.59 17.558 18.395C16.6757 19.2871 15.7129 20.0958 14.682 20.811L14.256 21.101L14.056 21.234L13.679 21.474L13.343 21.679L12.927 21.921C12.6446 22.0822 12.3251 22.1669 12 22.1669C11.6749 22.1669 11.3554 22.0822 11.073 21.921L10.657 21.679L10.137 21.359L9.945 21.234L9.535 20.961C8.42283 20.2085 7.3869 19.3491 6.442 18.395C4.676 16.589 3 14.074 3 11C3 8.61305 3.94821 6.32387 5.63604 4.63604C7.32387 2.94821 9.61305 2 12 2ZM12 4C10.1435 4 8.36301 4.7375 7.05025 6.05025C5.7375 7.36301 5 9.14348 5 11C5 13.322 6.272 15.36 7.871 16.996C8.55853 17.692 9.30166 18.3308 10.093 18.906L10.551 19.232C10.699 19.3353 10.8413 19.4313 10.978 19.52L11.368 19.77L11.711 19.979L12 20.148L12.455 19.879L12.822 19.649C13.0173 19.525 13.2263 19.386 13.449 19.232L13.907 18.906C14.6983 18.3308 15.4415 17.692 16.129 16.996C17.728 15.361 19 13.322 19 11C19 9.14348 18.2625 7.36301 16.9497 6.05025C15.637 4.7375 13.8565 4 12 4ZM12 7C13.0609 7 14.0783 7.42143 14.8284 8.17157C15.5786 8.92172 16 9.93913 16 11C16 12.0609 15.5786 13.0783 14.8284 13.8284C14.0783 14.5786 13.0609 15 12 15C10.9391 15 9.92172 14.5786 9.17157 13.8284C8.42143 13.0783 8 12.0609 8 11C8 9.93913 8.42143 8.92172 9.17157 8.17157C9.92172 7.42143 10.9391 7 12 7ZM12 9C11.4696 9 10.9609 9.21071 10.5858 9.58579C10.2107 9.96086 10 10.4696 10 11C10 11.5304 10.2107 12.0391 10.5858 12.4142C10.9609 12.7893 11.4696 13 12 13C12.5304 13 13.0391 12.7893 13.4142 12.4142C13.7893 12.0391 14 11.5304 14 11C14 10.4696 13.7893 9.96086 13.4142 9.58579C13.0391 9.21071 12.5304 9 12 9Z"
                        fill="black"
                        fill-opacity="0.6"
                      />
                    </svg>
                  </div>
                </div>
                <div className="form-group inputWithIcon">
                  <label>Phone</label>
                  <div className="input-comp">
                    <input type="email" placeholder={adminData?.phone} />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="fa-envelope"
                    >
                      <path
                        d="M16.6292 13.891L17.0852 13.438L16.0262 12.374L15.5722 12.827L16.6292 13.891ZM18.6142 13.248L20.5252 14.287L21.2402 12.969L19.3302 11.931L18.6142 13.248ZM20.8922 16.351L19.4722 17.764L20.5292 18.827L21.9492 17.415L20.8922 16.351ZM18.6062 18.218C17.1562 18.354 13.4062 18.233 9.34417 14.195L8.28617 15.258C12.7182 19.665 16.9372 19.881 18.7462 19.712L18.6062 18.218ZM9.34417 14.195C5.47317 10.345 4.83117 7.10802 4.75117 5.70302L3.25317 5.78802C3.35317 7.55602 4.14817 11.144 8.28617 15.258L9.34417 14.195ZM10.7192 8.01502L11.0062 7.72902L9.95017 6.66602L9.66317 6.95102L10.7192 8.01502ZM11.2342 4.09402L9.97417 2.41002L8.77317 3.31002L10.0332 4.99302L11.2342 4.09402ZM5.73317 2.04302L4.16317 3.60302L5.22117 4.66702L6.79017 3.10702L5.73317 2.04302ZM10.1912 7.48302C9.66117 6.95102 9.66117 6.95102 9.66117 6.95302H9.65917L9.65617 6.95702C9.60865 7.00493 9.5661 7.05754 9.52917 7.11402C9.47517 7.19402 9.41617 7.29902 9.36617 7.43202C9.24445 7.77535 9.21412 8.14443 9.27817 8.50302C9.41217 9.36802 10.0082 10.511 11.5342 12.029L12.5922 10.965C11.1632 9.54502 10.8232 8.68102 10.7602 8.27302C10.7302 8.07902 10.7612 7.98302 10.7702 7.96102C10.7762 7.94769 10.7762 7.94569 10.7702 7.95502C10.7613 7.96882 10.7512 7.98186 10.7402 7.99402L10.7302 8.00402L10.7202 8.01302L10.1912 7.48302ZM11.5342 12.029C13.0612 13.547 14.2102 14.139 15.0762 14.271C15.5192 14.339 15.8762 14.285 16.1472 14.184C16.299 14.1285 16.4408 14.0488 16.5672 13.948L16.6172 13.903L16.6242 13.897L16.6272 13.894L16.6282 13.892C16.6282 13.892 16.6292 13.891 16.1002 13.359C15.5702 12.827 15.5732 12.826 15.5732 12.826L15.5752 12.824L15.5772 12.822L15.5832 12.817L15.5932 12.807L15.6312 12.777C15.6405 12.771 15.6382 12.7717 15.6242 12.779C15.5992 12.788 15.5012 12.819 15.3042 12.789C14.8902 12.725 14.0202 12.385 12.5922 10.965L11.5342 12.029ZM9.97417 2.40902C8.95417 1.04902 6.95017 0.833021 5.73317 2.04302L6.79017 3.10702C7.32217 2.57802 8.26617 2.63302 8.77317 3.31002L9.97417 2.40902ZM4.75217 5.70402C4.73217 5.35802 4.89117 4.99602 5.22117 4.66802L4.16217 3.60402C3.62517 4.13802 3.20217 4.89402 3.25317 5.78802L4.75217 5.70402ZM19.4722 17.764C19.1982 18.038 18.9022 18.192 18.6072 18.219L18.7462 19.712C19.4812 19.643 20.0822 19.273 20.5302 18.828L19.4722 17.764ZM11.0062 7.72902C11.9912 6.75002 12.0642 5.20302 11.2352 4.09502L10.0342 4.99402C10.4372 5.53302 10.3772 6.24002 9.94917 6.66702L11.0062 7.72902ZM20.5262 14.288C21.3432 14.732 21.4702 15.778 20.8932 16.352L21.9512 17.415C23.2912 16.082 22.8782 13.859 21.2412 12.97L20.5262 14.288ZM17.0852 13.439C17.4692 13.057 18.0872 12.963 18.6152 13.249L19.3312 11.932C18.2472 11.342 16.9032 11.505 16.0272 12.375L17.0852 13.439Z"
                        fill="black"
                        fill-opacity="0.6"
                      />
                    </svg>
                  </div>
                </div>
                <div className="form-group inputWithIcon">
                  <label>Email</label>
                  <div className="input-comp">
                    <input
                      type="email"
                      placeholder={adminData?.email}
                      readOnly
                      disabled
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="fa-envelope"
                    >
                      <path
                        d="M17.1816 3.5H6.68164C4.4725 3.5 2.68164 5.29086 2.68164 7.5V16.5C2.68164 18.7091 4.4725 20.5 6.68164 20.5H17.1816C19.3908 20.5 21.1816 18.7091 21.1816 16.5V7.5C21.1816 5.29086 19.3908 3.5 17.1816 3.5Z"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                      />
                      <path
                        d="M2.72852 7.59003L9.93352 11.72C10.5373 12.0704 11.223 12.2549 11.921 12.2549C12.6191 12.2549 13.3047 12.0704 13.9085 11.72L21.1335 7.59003"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="form-group inputWithIcon">
                  <label>Password</label>
                  <div className="input-comp">
                    <input type="email" placeholder="************" />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      className="fa-envelope"
                    >
                      <path
                        d="M2 16C2 13.172 2 11.757 2.879 10.879C3.757 10 5.172 10 8 10H16C18.828 10 20.243 10 21.121 10.879C22 11.757 22 13.172 22 16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22H8C5.172 22 3.757 22 2.879 21.121C2 20.243 2 18.828 2 16Z"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                      />
                      <path
                        d="M6 10V8C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8V10"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                      <path
                        d="M8 16H8.009M11.991 16H12M15.991 16H16"
                        stroke="black"
                        stroke-opacity="0.6"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </form>
              <button>Save changes</button>
            </div>
            {/* <div className="line"></div>
            <div className="profile-pictures">
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
              <div className="circle">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/photos/5a178e33aa72ad690140b567642de318.webp"
                  }
                  alt="avatar"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
export default Profile;
